/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Engine_LabelInputs */

const en_spellcheck_engine_label = /** @type {(inputs: Spellcheck_Engine_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spell check engine selection`)
};

const fr_spellcheck_engine_label = /** @type {(inputs: Spellcheck_Engine_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selection du moteur de verification orthographique`)
};

const de_spellcheck_engine_label = /** @type {(inputs: Spellcheck_Engine_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswahl der Rechtschreibprüfung`)
};

const it_spellcheck_engine_label = /** @type {(inputs: Spellcheck_Engine_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezione del motore di controllo ortografico`)
};

const ru_spellcheck_engine_label = /** @type {(inputs: Spellcheck_Engine_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбор механизма проверки орфографии`)
};

const es_spellcheck_engine_label = /** @type {(inputs: Spellcheck_Engine_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selección del motor de corrección ortográfica`)
};

const zh_cn2_spellcheck_engine_label = /** @type {(inputs: Spellcheck_Engine_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拼写检查引擎选择`)
};

const ja_spellcheck_engine_label = /** @type {(inputs: Spellcheck_Engine_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スペルチェックエンジンの選択`)
};

const hi_spellcheck_engine_label = /** @type {(inputs: Spellcheck_Engine_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तनी जाँच इंजन का चयन`)
};

const pt_pt2_spellcheck_engine_label = /** @type {(inputs: Spellcheck_Engine_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seleção do mecanismo de verificação ortográfica`)
};

/**
* | output |
* | --- |
* | "Spell check engine selection" |
*
* @param {Spellcheck_Engine_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_engine_label = /** @type {((inputs?: Spellcheck_Engine_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Engine_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_engine_label(inputs)
	if (locale === "de") return de_spellcheck_engine_label(inputs)
	if (locale === "it") return it_spellcheck_engine_label(inputs)
	if (locale === "ru") return ru_spellcheck_engine_label(inputs)
	if (locale === "es") return es_spellcheck_engine_label(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_engine_label(inputs)
	if (locale === "ja") return ja_spellcheck_engine_label(inputs)
	if (locale === "hi") return hi_spellcheck_engine_label(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_engine_label(inputs)
	return en_spellcheck_engine_label(inputs)
});